import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[decimalInput]',
})
export class DecimalInputDirective implements OnInit {
  private readonly control = inject(NgControl);
  private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  numDecimals = input(2);

  ngOnInit() {
    if (this.el.nativeElement.type === 'number') {
      this.el.nativeElement.addEventListener('blur', () => {
        if (
          this.control.control !== null &&
          typeof this.control.control.value === 'number' &&
          this.control.control.value % 1 !== 0
        ) {
          const value = this.control.control.value;
          this.control.control.setValue(
            Number(value.toFixed(this.numDecimals())),
            {
              emitEvent: false,
            }
          );
        }
      });
    }
  }
}
